import PricingPage, { Props } from "page-components/PricingPage/PricingPage";
import {
  GetAllV2TeamServiceTiersDocument,
  GetAllV2TeamServiceTiersQuery,
} from "lib/types/graphql";
import { apolloCore } from "lib/apollo/apollo";

import type { GetStaticProps } from "next";

export default PricingPage;

export const getStaticProps: GetStaticProps<Props> = async () => {
  const {
    data: { team_service_tiers: teamServiceTiers },
  } = await apolloCore.query<GetAllV2TeamServiceTiersQuery>({
    query: GetAllV2TeamServiceTiersDocument,
    fetchPolicy: "no-cache",
  });
  return {
    props: {
      teamServiceTiers,
    },
    revalidate: 15 * 60, // 15 minute cache
  };
};
